import React, { Component } from 'react';
import { isMobile, isTablet } from 'react-device-detect';

import { getParkingLotsNear } from '../../../utils/api';
import GoogleMapComponent from '../GoogleMapComponent';
import ParkingMarker from './ParkingMarker';


class ParkingMap extends Component {

  state = {
    parkingLots: [],
    markerOpenedId: null,
    isGalleryMobileComponent: false,
    isFullscreenMobile: false,
    orientationHorizontalMobile: false,
  };


  componentDidMount() {
    const { coordinates: { latitude, longitude } } = this.props;

    isMobile && this.setState({ isGalleryMobileComponent: true });

    if (isMobile && !isTablet) {
      window.innerHeight < window.innerWidth && this.setState({
        orientationHorizontalMobile: true
      });
      window.addEventListener('orientationchange', this.handleOrientationChange);
    }

    getParkingLotsNear(latitude, longitude)
      .then(res => {
        const parkingLots = res.data.parking_lots;
        this.setState({ parkingLots });
      })
      .catch(error => {
        console.error(error);
      });
  };


  handleOrientationChange = () =>
    this.setState({ orientationHorizontalMobile: !this.state.orientationHorizontalMobile });


  handleFullscreenMobile = () =>
    this.setState({ isFullscreenMobile: !this.state.isFullscreenMobile });


  updateMarkerOpenedId = (marker_id) =>
    this.setState({ markerOpenedId: marker_id });


  markers = () => {
    return this.state.parkingLots.map(marker => (
      <ParkingMarker
        marker={marker}
        markerOpenedId={this.state.markerOpenedId}
        key={marker.id}
        updateMarkerOpenedId={this.updateMarkerOpenedId} />
    ));
  };


  render() {
    const { coordinates: { latitude, longitude }, googleApiKey } = this.props;
    const { isFullscreenMobile, isGalleryMobileComponent, orientationHorizontalMobile } = this.state;
    const coordinatesObj = { lat: latitude, lng: longitude };
    const containerClass = `map-container${isFullscreenMobile ? ' fullscreen-mobile' : ''}`;


    return (
      <GoogleMapComponent
        containerClass={containerClass}
        containerElement={<div className="bottom-map-container" />}
        coordinates={coordinatesObj}
        googleApiKey={googleApiKey}
        handleFullscreenMobile={this.handleFullscreenMobile}
        isFullscreenMobile={isFullscreenMobile}
        isGalleryMobileComponent={isGalleryMobileComponent}
        isMobile={isMobile && !isTablet}
        markers={this.markers()}
        mapElement={<div id="location-react-map" className="bottom-location-map" />}
        orientationHorizontalMobile={orientationHorizontalMobile}
      />
    );
  }
}

export default ParkingMap;
